import * as THREE from 'three'
import Experience from '../../Experience'
import vertexShader from '../../../shaders/fireworks/vertex.glsl'
import fragmentShader from '../../../shaders/fireworks/fragment.glsl'
import anim from '../../Utils/Anim'

export default class ParticleSystem {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene

    }

    createFire = (count, position, size, radius, color) => {

        const positionArray = new Float32Array(count * 3)
        const sizesArray = new Float32Array(count)
        for (let i = 0; i < count; i++) {
            const i3 = i * 3


            const position = new THREE.Vector3()
            const halfSize = radius / 2 // ou autre selon ton carré

            // Choisir un bord aléatoire du carré
            const side = Math.floor(Math.random() * 3)

            switch (side) {
                case 0: // Haut
                    position.set(
                        THREE.MathUtils.randFloat(-halfSize, halfSize),
                        halfSize - Math.random() * 0.05,
                        (Math.random() - 0.5) * 0.5 * Math.random() * Math.random()
                    )
                    break

                case 1: // Gauche
                    position.set(
                        -halfSize + Math.random() * 0.05,
                        THREE.MathUtils.randFloat(-halfSize, halfSize),
                        (Math.random() - 0.5) * 0.5 * Math.random() * Math.random()
                    )
                    break
                case 2: // Droite
                    position.set(
                        halfSize - Math.random() * 0.05,
                        THREE.MathUtils.randFloat(-halfSize, halfSize),
                        (Math.random() - 0.5) * 0.5 * Math.random() * Math.random()
                    )
                    break
            }


            positionArray[i3] = position.x
            positionArray[i3 + 1] = position.y
            positionArray[i3 + 2] = position.z

            // attribut de size
            sizesArray[i] = Math.random()
        }
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3));
        geometry.setAttribute('a_size', new THREE.BufferAttribute(sizesArray, 1));
        const material = new THREE.ShaderMaterial({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            transparent: true,
            depthWrite: false,
            depthTest: true,
            blending: THREE.AdditiveBlending,
            uniforms: {
                u_size: new THREE.Uniform(size),
                u_resolution: new THREE.Uniform(new THREE.Vector2(this.experience.sizes.width, this.experience.sizes.height)),
                u_color: new THREE.Uniform(color),
                u_progress: new THREE.Uniform(0),
            }

        });
        const firework = new THREE.Points(geometry, material);
        firework.layers.enable(1)
        firework.position.copy(position)
        firework.rotation.y = Math.PI * 0.5
        this.scene.add(firework)

        const destroyScene = () => {
            material.dispose();
            geometry.dispose();
            this.scene.remove(firework);
        };

        anim.to(material.uniforms.u_progress, {
            value: 1, duration: 1, onComplete: () => destroyScene()
        })

    }
}